import { UikitPlugin, useDefaultValidators } from '@hz/ui-kit'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(UikitPlugin, {})
  useDefaultValidators()
})
